import { Button, Space, Table } from 'antd'
import { FC, useState } from 'react'
import styled from 'styled-components'
import PageLayout from '../../../components/page-layout/page-layout'
import TableWrapper from '../../../components/table-wrapper/table-wrapper'
import useErrorModal from '../../../hooks/api/use-error-modal'
import {
    useDeleteShiftScheduleMutation,
    useGetShiftSchedulesQuery,
} from '../../../store/api/shift-schedules-api'
import { useGetShiftTypesQuery } from '../../../store/api/shift-types-api'
import ShiftSchedule from '../../../types/api/shift-schedule'
import { EndpointQueryParameters } from '../../../types/strapi/strapi'
import { getColumns } from './columns'
import ShiftScheduleModal from './components/shift-schedule-modal'

const PageContent = styled.div`
    display: flex;
    flex: auto;
    flex-direction: column;
    min-height: 0;
`

const Toolbar = styled(Space)`
    margin-bottom: 16px;
`

const queryParams: EndpointQueryParameters = {
    fields: ['documentId', 'date', 'statusEnum'],
    populate: {
        employee: {
            fields: ['documentId', 'username'],
        },
        shiftType: {
            fields: ['documentId', 'name'],
        },
    },
    pagination: {
        page: 1,
        pageSize: 100,
    },
    sort: ['createdAt:desc']
}

const shiftTypesQueryParams: EndpointQueryParameters = {
    fields: ['documentId', 'name']
}

const ShiftsPage: FC = () => {
    const { data, isLoading } = useGetShiftSchedulesQuery(queryParams)
    const { data: shiftTypes } =
        useGetShiftTypesQuery(shiftTypesQueryParams)
    const [deleteShiftSchedule, deleteState] = useDeleteShiftScheduleMutation()
    const [modalOpen, setModalOpen] = useState(false)
    const [editingShiftSchedule, setEditingShiftSchedule] = useState<ShiftSchedule | null>(null)

    useErrorModal(deleteState, 'Ошибка удаления смены')

    const handleAdd = () => {
        setEditingShiftSchedule(null)
        setModalOpen(true)
    }

    const handleEdit = (shiftSchedule: ShiftSchedule) => {
        setEditingShiftSchedule(shiftSchedule)
        setModalOpen(true)
    }

    const handleClose = () => {
        setModalOpen(false)
        setEditingShiftSchedule(null)
    }

    const handleDelete = async (shiftSchedule: ShiftSchedule) => {
        await deleteShiftSchedule(shiftSchedule.documentId).unwrap()
    }

    return (
        <PageLayout title='Смены'>
            <PageContent>
                <Toolbar>
                    <Button type='primary' onClick={handleAdd}>
                        Добавить смену
                    </Button>
                </Toolbar>
                <TableWrapper>
                    <Table
                        rowKey='documentId'
                        loading={isLoading}
                        columns={getColumns({
                            onEdit: handleEdit,
                            onDelete: handleDelete,
                            isDeleting: deleteState.isLoading,
                        })}
                        dataSource={data?.data || []}
                    />
                </TableWrapper>
                <ShiftScheduleModal
                    open={modalOpen}
                    shiftSchedule={editingShiftSchedule}
                    shiftTypes={shiftTypes?.data || []}
                    onClose={handleClose}
                />
            </PageContent>
        </PageLayout>
    )
}

export default ShiftsPage
